import { type TFunction } from 'i18next';
import { type ContractsResponse } from '@common/types/api';

interface Contract {
  readonly id: number;
  readonly startDate?: Date;
  readonly endDate?: Date;
  readonly contractNumber: string;
}

export interface ContractType {
  readonly id: number;
  readonly name: string;
}

export interface ContractTypeOption {
  value: number;
  text: string;
}
export const createContractFromResponse = (apiContract: ContractsResponse): Contract => ({
  id: apiContract.id,
  startDate: apiContract.startDate ? new Date(apiContract.startDate) : undefined,
  endDate: apiContract.endDate ? new Date(apiContract.endDate) : undefined,
  contractNumber: apiContract.contractNumber,
});

export const noTypeContractTypeId = -1; // Agreed with BE team

export const noTypeContractType: ContractType = {
  id: noTypeContractTypeId,
  name: 'CONTRACT_NO_TYPE',
};

const mapToContractTypeOption = (
  type: ContractType,
  t: TFunction<'translation'>,
): ContractTypeOption => ({
  value: type.id,
  text: t(type.name),
});

export const mapToContractTypeOptions = (
  contractTypes: ContractType[],
  t: TFunction<'translation'>,
) => {
  const result = [...contractTypes.map((type) => mapToContractTypeOption(type, t))]
    .sort((a, b) => a.text.localeCompare(b.text));
  if (result.length > 0) {
    result.unshift(mapToContractTypeOption(noTypeContractType, t));
  }
  return result;
};

export default Contract;
